module.exports = __webpack_public_path__ + "img/home-mob-1.1aaed5ef.svg";